import type { ViewFieldsFragment } from '@salescore/client-api'
import { deleteDescendantViewIds, setChildViewId, useAppDispatch } from '@salescore/client-redux'
import { useEffect } from 'react'

export const useSetChildViewId = (childViewId: string, view: ViewFieldsFragment) => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(setChildViewId({ viewId: view.id, childViewId }))
    return () => {
      dispatch(deleteDescendantViewIds(view.id))
    }
  }, [])
}
